'use strict';

var _slicedToArray = require("D:\\Users\\Javier\\web-mn\\node_modules\\@babel\\runtime/helpers/slicedToArray");

function round(method, number, precision) {
  if (typeof number !== 'number') {
    throw new TypeError('Expected value to be a number');
  }

  if (!Number.isInteger(precision)) {
    throw new TypeError('Expected precision to be an integer');
  }

  var isRoundingAndNegative = method === 'round' && number < 0;

  if (isRoundingAndNegative) {
    number = Math.abs(number);
  }

  var exponent;

  var _$split = "".concat(number, "e").split('e');

  var _$split2 = _slicedToArray(_$split, 2);

  number = _$split2[0];
  exponent = _$split2[1];
  var result = Math[method]("".concat(number, "e").concat(Number(exponent) + precision));

  var _$split3 = "".concat(result, "e").split('e');

  var _$split4 = _slicedToArray(_$split3, 2);

  number = _$split4[0];
  exponent = _$split4[1];
  result = Number("".concat(number, "e").concat(Number(exponent) - precision));

  if (isRoundingAndNegative) {
    result = -result;
  }

  return result;
}

module.exports = round.bind(null, 'round');
module.exports.up = round.bind(null, 'ceil');
module.exports.down = round.bind(null, 'floor');